import { render } from "./ConfirmOrderHead.vue?vue&type=template&id=cd819752&scoped=true"
import script from "./ConfirmOrderHead.vue?vue&type=script&lang=js"
export * from "./ConfirmOrderHead.vue?vue&type=script&lang=js"

import "./ConfirmOrderHead.vue?vue&type=style&index=0&id=cd819752&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd819752"]])

export default __exports__